import { render, staticRenderFns } from "./AddressIndex.vue?vue&type=template&id=4608902a"
import script from "./AddressIndex.vue?vue&type=script&lang=js"
export * from "./AddressIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports